export default "__VITE_ASSET__2723d7c6__"